import React from 'react';
import { motion } from 'framer-motion';
import styles from './PageValues.module.css';

const REASONS = [
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#8E44AD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <ellipse cx="12" cy="5" rx="9" ry="3" />
        <path d="M3 5v4c0 1.66 4 3 9 3s9-1.34 9-3V5" />
        <path d="M3 9v4c0 1.66 4 3 9 3s9-1.34 9-3V9" />
        <path d="M3 13v4c0 1.66 4 3 9 3s9-1.34 9-3v-4" />
      </svg>
    ),
    title: <>Revenus directement liés aux <span className={styles.accentViolet}>créations.</span></>
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1D5FD1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
      </svg>
    ),
    title: <>Distribution <span className={styles.accentBlue}>transparente.</span></>
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FF6B00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    title: <>Actifs <span className={styles.accentOrange}>durables</span> dans le temps.</>
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#146C6E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
        <circle cx="12" cy="12" r="2" />
      </svg>
    ),
    title: <>Conçue pour faire <span className={styles.accentTeal}>grandir</span> les créateurs.</>
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#8E44AD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: <>Écosystème basé sur la <span className={styles.accentViolet}>contribution.</span></>
  }
];

const VALUES = [
  {
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
    ),
    title: "Ce que vous créez vous appartient.",
    text: "Les créateurs restent propriétaires de leurs contenus et revenus."
  },
  {
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
      </svg>
    ),
    title: "La clarté avant tout.",
    text: "Des règles simples, compréhensibles et prévisibles."
  },
  {
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: "Construit avec ses membres.",
    text: "Chaque utilisateur participe à l’évolution de l’écosystème."
  }
];

const IMPACTS = [
  {
    title: "Chaque création enrichit la plateforme.",
    text: "Plus il y a de contenus, plus l’écosystème devient puissant."
  },
  {
    // "Pionniers" -> "Fondateurs" : lexique officiel du projet, le reste du
    // site a ete renomme et cette ligne etait la derniere a ne pas l'etre.
    title: "Les Fondateurs définissent la structure.",
    text: "Les premiers membres influencent la forme finale de TANGIG."
  }
];

export default function PageValues() {
  return (
    <section className={styles.section} data-navbar-theme="light">
      <div className={styles.container}>
        
        {/* BLOC 1 — RAISONS (Horizontal Scroll) */}
        <header className={styles.header}>
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={styles.titleLarge}
          >
            Pourquoi rejoindre TANGIG.
          </motion.h2>
        </header>

        <div className={styles.scrollContainer}>
          {REASONS.map((item, i) => (
            <motion.div
              key={i}
              className={styles.cardReason}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
            >
              <div className={styles.reasonIcon}>{item.icon}</div>
              <h3 className={styles.reasonTitle}>{item.title}</h3>
            </motion.div>
          ))}
        </div>

        {/* BLOC 2 — VALEURS (Grid 3) */}
        <div className={styles.valuesWrapper}>
          <header className={styles.header}>
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className={styles.titleLarge}
            >
              Ce qui compte vraiment.
            </motion.h2>
          </header>

          <div className={styles.valuesGrid}>
            {VALUES.map((val, i) => (
              <motion.div
                key={i}
                className={styles.cardValue}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                <div className={styles.valueIcon}>{val.icon}</div>
                <h3 className={styles.valueTitle}>{val.title}</h3>
                <p className={styles.valueText}>{val.text}</p>
              </motion.div>
            ))}
          </div>
        </div>

        {/* BLOC 3 — IMPACT / ÉCOSYSTÈME */}
        <div className={styles.impactWrapper}>
          <header className={styles.header}>
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className={styles.titleLarge}
            >
              Un écosystème qui se renforce avec chaque contribution.
            </motion.h2>
          </header>

          <div className={styles.impactGrid}>
            {IMPACTS.map((imp, i) => (
              <motion.div
                key={i}
                className={styles.cardImpact}
                initial={{ opacity: 0, scale: 0.98 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                <h3 className={styles.impactTitle}>{imp.title}</h3>
                <p className={styles.impactText}>{imp.text}</p>
              </motion.div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
